/// <amd-module name="Analytics/Common/Utilities/PublicProjectsQueryHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssUserClaimsService, UserClaims } from "VSS/Platform/UserClaims";

import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import * as AnalyticsResources from "Analytics/Common/Resources";

/** Used to check if query is operating on more than a single  project when run by a non-member user.
 *  Throws an exception if more than one project is being queried, rather than making an unsupported request on the service.
 */
export function forceProjectScoping(pageContext: IVssPageContext, projectIDs: string[], queryOptions: ODataQueryOptions): ODataQueryOptions {
    if (!isMemberUser(pageContext)) {
        // Only use the first unique instance of the ID's
        const matchingProjectIDs = projectIDs.filter((value: string, index: number, self: string[]) => {
            return self.indexOf(value) === index;
        });
        if (matchingProjectIDs && matchingProjectIDs.length === 1) {
            queryOptions.project = matchingProjectIDs[0];
        } else {
            throw AnalyticsResources.Exception_PublicUserOnlyAllowsSingleProjectQuery;
        }
    }

    return queryOptions;
}

function isMemberUser(pageContext: IVssPageContext) {
    return pageContext.getService<IVssUserClaimsService>("IVssUserClaimsService").hasClaim(UserClaims.Member);
}
